export default __webpack_public_path__ + "static/media/close_red.7651b1f6.svg";